module.exports = __webpack_public_path__ + "static/media/pop_box_open@2x.fe1a7b28.png";